module.exports = __webpack_public_path__ + "img/8.e20c175e.png";